import { useCallback } from "react";

import useTranslations from "@/shared/lang/useTranslations";

import {
  amountIssueMessage,
  BUY_RANGE_KEYS,
  type AmountIssue,
  type AmountRangeKeys,
} from "../utils/cryptoSwapAmountIssues";
import { limitPrecision, type PairPrecision } from "../utils/cryptoSwapFormat";
import { useAmountFormatter } from "./useAmountFormatter";

/** The sentence for an amount issue, identical wherever it shows: under the field or under the button. */
export function useAmountIssueText(pair?: PairPrecision | null, rangeKeys: AmountRangeKeys = BUY_RANGE_KEYS) {
  const { t } = useTranslations("cryptoSwaps");
  const format = useAmountFormatter(pair);

  return useCallback(
    (issue: AmountIssue) =>
      amountIssueMessage(
        issue,
        t,
        (amount, currency) => format(amount, currency, limitPrecision(currency, pair)),
        rangeKeys,
      ),
    [t, format, pair, rangeKeys],
  );
}
